<template>
    <div class="top_menu">    
        <div @click="()=> $router.push(`/user/${$route.params.id}`)" class="back_button"> ⬅️ Назад </div>
    </div>

    <div class="form">
          <p><b>Гражданство:</b> {{ this.citizenship[this.GetUserForm.citizenship] }} </p>
          <p><b>Размер ипотеки:</b> {{ this.GetUserForm.estimated_mortgage_amount }}</p>
          <p><b>Тип недвижимости:</b> {{this.accomodation_types[this.GetUserForm.accommodation_type]}}</p>
          <p><b>Размер первого взноса:</b> {{this.GetUserForm.down_payment_amount}} </p>
          <p><b>Срок ипотеки:</b> {{ this.GetUserForm.mortgage_term }} </p>
          <p><b>Дети после 2018:</b> {{this.symbols[this.GetUserForm.children_after_2018]}} </p>
          <p><b>Наличие кредитов:</b> {{symbols[this.GetUserForm.credits_in_the_past]}} </p>
          <p><b>Официальная работа:</b> {{ symbols[this.GetUserForm.official_job]}}</p>
          <p><b>Судимости:</b> {{ symbols[this.GetUserForm.convictions]}}</p>
          <p><b>Банкротство:</b> {{ symbols[this.GetUserForm.bankruptcy]}}</p>
          <p><b>Просрочки по платежам:</b> {{ symbols[this.GetUserForm.late_payments]}}</p>
          <p><b>Брак:</b> {{ symbols[this.GetUserForm.marriage]}}</p>
          <p><b>Количество детей:</b> {{ this.GetUserForm.children_amount }}</p>
    </div>
</template>

<script>
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';

    export default {
        data(){
            return{
                citizenship :{"ru": "Российская Федерация", "different": "Другое"},
                symbols: {"false": "❌", "true": "✅"},
                description: {"ru": "Российская Федерация", "different": "Другое"},
                accomodation_types: {"house": "Дом", "new_house": "Строительство дома", "flat": "Квартира",
                              "new_flat": "Новостройка", "commercial": "Коммерческая", "apart": "Апартаменты"}

            }
        },
        computed: {
        ...mapState({
            users: state => state.users,
            user_id: state => state.user_id,
            user_form: state => state.user_form
        }),
        ...mapGetters({
            GetUser: "GetUser",
            GetUserForm: "GetUserForm"
        })
     },




}
</script>

<style scoped>

.back_button {
    margin: 10px;
    padding: 5px;
}
.top_menu{
    display: flex;
    justify-content: space-between;
}
.form{
    overflow-x: hidden;
    padding: 30px;
}
</style>